import '../../theme/DefaultTheme';

import '../../components/Header/main';
import '../../components/Calculator/default';
import '../../components/Testimonials';
import '../../components/Footer';
